var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Inline from '../../spacing/Inline';
import IconButtonBase from './subcomponents';
const IconButton = (_a) => {
    var { id, ariaLabel, className, type = 'button', onClick, buttonText, restIcon, activeIcon, isStacked } = _a, props = __rest(_a, ["id", "ariaLabel", "className", "type", "onClick", "buttonText", "restIcon", "activeIcon", "isStacked"]);
    return (_jsxs(IconButtonBase, Object.assign({}, props, { id: id, className: className, type: type, "aria-label": ariaLabel, onClick: onClick, isStacked: isStacked }, { children: [_jsxs("span", Object.assign({ className: "restIcon" }, { children: [" ", restIcon] })), _jsxs("span", Object.assign({ className: "activeIcon" }, { children: [" ", activeIcon] })), !isStacked && _jsx(Inline, { size: "small" }), buttonText] })));
};
export default IconButton;
